"use client";

import { SWRConfig } from "swr";

export const WithSwrConfig = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => (
  <SWRConfig
    value={{
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    }}
  >
    {children}
  </SWRConfig>
);
